export const TAB_ALL = 'all';
export const TAB_PRODUCTS = 'products';
export const TAB_USER_MANUALS = 'userManuals';
export const TAB_STORES = 'stores';
export const TAB_ARTICLES = 'articles';
export const TAB_SERVICES = 'services';

export const TABS_ORDER = [TAB_ALL, TAB_PRODUCTS, TAB_ARTICLES, TAB_SERVICES, TAB_STORES, TAB_USER_MANUALS];

export const SEARCH_MIN_TERM_LENGTH = 3;
